export default __webpack_public_path__ + "static/media/hero-image.d10776f3.png";